import axios from 'axios';
import DBService from '~/settings/__modules__/utils/DBservice';
import {
  CommonService,
  UserOptionName,
} from '~/settings/service/CommonService';
import SyncService from './SyncService';

const STAMPSUGGESION_LANG_OPTION = UserOptionName.STAMPSUGGESION_LANG_OPTION;
const STAMPSUGGESION_LANG_V6_NOT_SET = 'not_set';

const STAMPSUGGESION_LANG_EN = 'StampSuggestion.lang.en';
const STAMPSUGGESION_LANG_KR = 'StampSuggestion.lang.kr';
const STAMPSUGGESION_LANG_JA = 'StampSuggestion.lang.ja';
const STAMPSUGGESION_LANG_CH = 'StampSuggestion.lang.ch';

export default class StampService {
  static async checkSupportLanguage() {
    const APIUrl = '/sticker/suggestion/lang';
    const resp = await axios.get(APIUrl);
    if (resp.status == 200) {
      return [null, resp.data];
    } else {
      return [new Error('ss.check.language'), null];
    }
  }

  static async syncData() {
    const result = await SyncService.sync();
    const langNames = Object.keys(result.langs);
    await DBService.removeDB();
    const tbales = langNames
      .map((x) => {
        return { name: x, keyPath: 'segment' };
      })
      .concat([
        { name: 'revision', keyPath: 'key' },
        { name: 'lang', keyPath: 'key' },
      ]);

    await DBService.createDB(tbales);
    try {
      langNames.forEach(function (lang) {
        DBService.insertKeywordItems(lang, result.langs[lang]);
      });
      DBService.writeVersion(result.version);
      DBService.writeLangs(langNames);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  static getUserOptionForLanguage(locale) {
    let localeOptions = CommonService.getOptionValue(
      STAMPSUGGESION_LANG_OPTION,
    );
    let result = false;
    if (localeOptions === STAMPSUGGESION_LANG_V6_NOT_SET) {
      //load the toptions before v6
      if (locale === 'en_US') {
        result = CommonService.getOptionValue(STAMPSUGGESION_LANG_EN);
      } else if (locale === 'ko_KR') {
        result = CommonService.getOptionValue(STAMPSUGGESION_LANG_KR);
      } else if (locale === 'ja_JP') {
        result = CommonService.getOptionValue(STAMPSUGGESION_LANG_JA);
      } else if (locale === 'zh_TW') {
        result = CommonService.getOptionValue(STAMPSUGGESION_LANG_CH);
      }
    } else {
      result = localeOptions.indexOf(locale) > -1;
    }
    return result;
  }

  static setUserOptionForLanguage(locale, enable) {
    let optionsMap = {};
    let optionValue = CommonService.getOptionValue(STAMPSUGGESION_LANG_OPTION);
    if (optionValue !== '' && optionValue !== STAMPSUGGESION_LANG_V6_NOT_SET) {
      optionValue.split(',').forEach((x) => {
        optionsMap[x] = true;
      });
    }
    optionsMap[locale] = enable;

    let newOptions = Object.keys(optionsMap)
      .filter((k) => {
        return optionsMap[k];
      })
      .map((k) => {
        return k;
      })
      .join(',');
    CommonService.setOptionValue(STAMPSUGGESION_LANG_OPTION, newOptions, false);
  }
}
